module.exports = __webpack_public_path__ + "static/media/powerarm.f29816a0.svg";